<template>
  <div class="step">
    <h3 class="title-step secundari">CUSTOMIZE BUTTONS:</h3>
    <div class="description-step">
      <div class="instructions">
        <div class="instIcon">
          <Icon icon="ph:sliders-fill" :rotate="1" />
        </div>
        <div class="instText">
          <h6>RGB CONTROLS</h6>
          <p>Set the color with the sliders</p>
        </div>
      </div>
      <div class="instructions">
        <div class="instIcon">
          <Icon icon="fluent:arrow-counterclockwise-24-filled" />
        </div>
        <div class="instText">
          <h6>RESET</h6>
          <p>Delete all your canvas and start again</p>
        </div>
      </div>
      <!-- <div class="instructions">
        <div class="instIcon">
          <Icon icon="fluent:circle-half-fill-24-regular" :rotate="1" />
        </div>
        <div class="instText">
          <h6>REVERSE</h6>
          <p>Invert your canvas</p>
        </div>
      </div> -->
      <div class="instructions speed">
        <div class="instIcon">
          <Icon icon="fluent:top-speed-24-filled" />
        </div>
        <div class="instText">
          <h6>SPEED</h6>
          <p>[ONLY FOR PIXEL COLLECTIONS!]</p>
          <p>Choose how fast your sequence of drawings will be displayed</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
export default {
  name: "info-component",
  components: {
    Icon,
  },
};
</script>

<style>
.instructions .instIcon {
  width: 38px;
  height: 38px;
  padding: 5px;
  background-color: #f7c544;
  border: 2px solid #ef8232;
  display: flex;
  justify-content: center;
  align-items: center;
}

.instructions .instIcon .iconify {
  margin: 0px;
  padding: 0px;
  font-size: 24px;
  color: #d72d20;
}

.instructions .instText {
  color: #fff;
  margin: 0px 0px 0px 18px;
  text-align: start;
}

.instructions .instText h6 {
  font-family: "Press Start 2P";
  font-size: 10px;
  padding: 0px;
  margin: 0px;
  text-transform: uppercase;
  text-align: start;
}

.instructions .instText p {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  margin: 0px;
}
</style>
